var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MenuGenerator"},[_vm._l((_vm._menu),function(item,index){return [(item.type === 'link')?_c('MenuGeneratorLink',{key:`link_${index}`,attrs:{"item":item}}):(item.type === 'segment')?_c('MenuGeneratorSegment',{key:`segment_${index}`,attrs:{"item":item,"depth":1}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }